if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      if (this.cartNotification) this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const formData = new FormData(this.form);
      formData.append('sections', 'header');
      formData.append('sections_url', window.location.pathname);
      const addonIds = [...this.form.querySelectorAll('select[data-addon-select]')]
        .map((select) => select.value)
        .filter(Boolean);
      const quantity = Number(formData.get('quantity')) || 1;
      const cardSelect = this.form.querySelector('[data-card-select]');
      const cardMessage = this.form.querySelector('[data-card-message]');
      const messageText = cardMessage ? cardMessage.value.trim() : '';

      const addItem = (body, asJson) => {
        const request = fetchConfig('javascript');
        request.headers['X-Requested-With'] = 'XMLHttpRequest';
        if (asJson) {
          request.headers['Content-Type'] = 'application/json';
          request.body = JSON.stringify(body);
        } else {
          delete request.headers['Content-Type'];
          request.body = body;
        }
        return fetch(`${routes.cart_add_url}`, request).then((response) => response.json());
      };

      addonIds.reduce(
        (chain, id) => chain.then(() => {
          const item = { id: Number(id), quantity };
          if (cardSelect && String(cardSelect.value) === String(id) && messageText) {
            item.properties = { 'Card message': messageText };
          }
          return addItem(item, true);
        }),
        Promise.resolve()
      )
        .then(() => addItem(formData, false))
        .then((response) => {
          if (response.status) {
            this.querySelector('.wbquicksuccess').classList.add('hidden'); // Webibazaar Quickview Message
            this.handleErrorMessage(response.description);
            return;
          }

          const headerHtml = response.sections && response.sections.header;
          if (headerHtml) {
            const nextCart = new DOMParser().parseFromString(headerHtml, 'text/html').querySelector('#cart-icon-bubble');
            const currentCart = document.querySelector('#cart-icon-bubble');
            if (nextCart && currentCart) currentCart.replaceWith(nextCart);
          }
          document.body.classList.add('no-scroll', 'cartOpen');
          this.querySelector('.wbquicksuccess').classList.remove('hidden'); // Webibazaar Quickview Message
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
